module.exports = function ($sce, settingsService, $state, $sanitize) {
    return {
        restrict: 'E',
        scope: {
            isRecipes: '=',
        },
        link($scope) {
            $scope.searchTerm = '';
            $scope.originalSearchTerm = $sanitize($state.params.searchTerm);

            $scope.pageName = 'results';
            if ($state.current.name === 'shop.search.products') {
                $scope.pageName = 'products';
            } else if ($state.current.name === 'shop.search.specials') {
                $scope.pageName = 'specials';
            } else if ($state.current.name === 'shop.search.recipes') {
                $scope.pageName = 'recipes';
            } else if ($state.current.name === 'shop.search.articles') {
                $scope.pageName = 'articles';
            }

            settingsService.getSettingValue('Search', 'ZeroSearchResultsMessage').then((setting) => {
                const emptyProductSearchMessageBeforeAfter = setting.split('{search}');
                $scope.SearchTerm = $state.params.searchTerm;
                $scope.EmptyProductSearchMessageBefore = $sce.trustAsHtml(emptyProductSearchMessageBeforeAfter[0]);
                $scope.EmptyProductSearchMessageAfter = $sce.trustAsHtml(emptyProductSearchMessageBeforeAfter[1]);
            });
        },
        template: require('./search-zero-results.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/search/search-zero-results.directive.js